import React, { useState } from "react";
import { connect } from "react-redux";
import {
  FooterLink,
  FooterSocialLink,
} from "discover.medical.react-component-library";
import TermsOfUseDialog from "../../components/TermsOfUse";
import { log } from "../../telemetry/analytics";
import { NAVIGATION_CLICKED } from "../../telemetry/constants";
import { StyledFooter, StyledFooterContainer } from "./Footer.styled";

const TERMS_OF_USE_URL =
  "https://resources.ebsco.zone/ebsco-policies/terms-of-use.md"; // NOSONAR

const AppFooter = (props) => {
  const { footerData } = props;
  const { footerLinks, copyright, socialLinks, logo } = footerData;
  const [isTermsDlgOpen, setIsTermsDlgOpen] = useState(false);
  const closeTermsDialog = () => setIsTermsDlgOpen(false);

  const hasOsano = typeof window !== "undefined" && window.Osano;

  const handleOnClick = (event) => {
    // If Terms & Condition link (which is at TERMS_OF_USE_URL pop up dialog to display)
    const target = event ? event?.target?.href : window.event.srcElement.href;
    if (target.indexOf("ebsco-policies") >= 0) {
      event.preventDefault();
      event.stopPropagation();
      setIsTermsDlgOpen(true);
      return;
    }
    if (target.indexOf("mobile") >= 0) {
      log(NAVIGATION_CLICKED, {
        affordance: "footer",
        navigate_to: "mobile",
        navigateFrom: null,
      });
    }
  };

  const manageCookies = () => {
    window.Osano.cm.showDrawer();
  };

  return (
    <StyledFooterContainer>
      <StyledFooter
        links={footerLinks?.map((link) =>
          !link.cookiesLink || hasOsano ? (
            <FooterLink
              key={link.url}
              data-testid="footer-links"
              href={link.url}
              target={link.target}
              onClick={link.cookiesLink ? manageCookies : handleOnClick}
            >
              {link.text}
            </FooterLink>
          ) : null,
        )}
        socialLinks={socialLinks?.map((link) => (
          <FooterSocialLink
            key={link.url}
            data-testid="footer-social-links"
            glyph={link.name}
            href={link.url}
          />
        ))}
        logo={
          <img
            style={{ height: logo.height }}
            src={logo?.src}
            alt={logo?.alt}
          />
        }
        copyright={copyright?.text}
      />
      <TermsOfUseDialog
        isTermsDlgOpen={isTermsDlgOpen}
        handleCloseDlg={closeTermsDialog}
        termsUrl={TERMS_OF_USE_URL}
      />
    </StyledFooterContainer>
  );
};

export const mapStateToProps = ({ productInfo }) => ({
  footerData: productInfo.footer,
});

export default connect(mapStateToProps)(AppFooter);
